export default __webpack_public_path__ + "static/media/MP5_4.d3380898.png";